import { cn } from "@/libs/utils";

export default function ChevronIcon({
  size = 16,
  width,
  dir = "down",
  height,
  ...rest
}: {
  dir?: "up" | "down" | "left" | "right";
  size?: number;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  const rotate =
    dir === "up"
      ? "rotate-180"
      : dir === "left"
        ? "rotate-90"
        : dir === "right"
          ? "-rotate-90"
          : "";
  return (
    <div className={cn(rotate, "flex items-center justify-center")}>
      <svg
        {...rest}
        width={width || size}
        height={height || width}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.78113 9.01519L4.5181 5.64436C4.29554 5.41445 3.93921 5.41923 3.72222 5.65504C3.50522 5.89084 3.50973 6.26838 3.73229 6.4983L7.38822 10.275H8.17403L11.83 6.4983C12.0525 6.26838 12.057 5.89084 11.84 5.65504C11.623 5.41923 11.2667 5.41445 11.0442 5.64436L7.78113 9.01519Z"
          // fill="white"
        />
      </svg>
    </div>
  );
}
